import { action, atom } from '@reatom/framework'

import { AsyncStateN, pipe } from '@blade/std-lib'
import { Deeplink, DeeplinkURL } from '@root/entities/deeplinking'
import { selectedNetworkAtom } from '@root/entities/network'
import { profileStateAtom } from '@root/entities/profile'
import { environmentAtom } from '@root/shared'

import { InviteCode } from '../model'

export const joinedInviteCodeAtom = atom<InviteCode | undefined>(
  undefined,
  'joinedInviteCodeAtom',
)

export const referralInfoStateAtom = atom((ctx) => {
  const profileState = ctx.spy(profileStateAtom)
  const network = ctx.spy(selectedNetworkAtom)
  return pipe(
    profileState,
    AsyncStateN.map((it) => it.referralInfo[network]),
  )
}, 'referralInfoStateAtom')

export const referralInfoAtom = atom(
  (ctx) => ctx.spy(referralInfoStateAtom).value,
  'referralInfoAtom',
)

export const referralBalanceNativeAtom = atom((ctx) => {
  const profile = ctx.spy(referralInfoAtom)
  return profile?.referralBalanceNative
}, 'referralBalanceNativeAtom')

export const referralCodeAtom = atom((ctx) => {
  const referralInfo = ctx.spy(referralInfoAtom)
  return referralInfo?.code
}, 'referralCodeAtom')

export const existingInviteCodeAtom = atom((ctx) => {
  const referralInfo = ctx.spy(referralInfoAtom)
  return referralInfo?.inviteCode
}, 'existingInviteCodeAtom')

export const referralLinkAtom = atom((ctx) => {
  const referralCode = ctx.spy(referralCodeAtom)
  const webUrl = ctx.get(environmentAtom).webUrl

  if (referralCode) {
    return DeeplinkURL.fromDeeplink(
      // refcode became inviteCode
      new Deeplink.InviteCodeJoin({ inviteCode: InviteCode(referralCode) }),
      webUrl,
    )
  }
}, 'referralLinkAtom')

export interface OpenChangeInviteCodeDialogPayload {
  inviteCode: InviteCode | undefined
}

export const openChangeInviteCodeDialogEvent =
  // eslint-disable-next-line @reatom/unit-naming-rule
  action<OpenChangeInviteCodeDialogPayload>('openChangeReferralCodeDialogEvent')

export * from './reatom-user-referrals'
export * from './referral-requests'
